import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=7ab46895"
import script from "./Tiers.vue?vue&type=script&lang=js"
export * from "./Tiers.vue?vue&type=script&lang=js"
import style0 from "./Tiers.vue?vue&type=style&index=0&id=7ab46895&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports